/* GG sale countdowns (snippets/gg-countdown.liquid). One interval drives every .gg-cd on the page.
   Test switch: on a theme whose role is not "main", ?gg_cd_test=N makes every end now + N seconds. */
(function () {
  if (window.__ggCountdown) return;
  window.__ggCountdown = true;

  var testEnd = null;
  try {
    var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
    var m = location.search.match(/[?&]gg_cd_test=(\d+)/);
    if (m && role && role !== 'main') testEnd = Date.now() + parseInt(m[1], 10) * 1000;
  } catch (e) {}

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function tick() {
    var now = Date.now();
    document.querySelectorAll('.gg-cd').forEach(function (el) {
      var end = testEnd !== null ? testEnd : parseInt(el.getAttribute('data-gg-end'), 10) * 1000;
      var left = Math.floor((end - now) / 1000);
      var wrap = el.closest('[data-gg-cd-wrap]');
      if (!(left > 0)) {
        el.remove();
        if (wrap) wrap.hidden = true;
        return;
      }
      var parts = { d: Math.floor(left / 86400), h: Math.floor(left % 86400 / 3600), m: Math.floor(left % 3600 / 60), s: left % 60 };
      el.querySelectorAll('[data-gg-cd]').forEach(function (n) {
        var v = pad(parts[n.getAttribute('data-gg-cd')]);
        if (n.textContent !== v) n.textContent = v;
      });
      if (el.hidden) el.hidden = false;
      if (wrap && wrap.hidden) wrap.hidden = false;
    });
  }

  tick();
  setInterval(tick, 1000);
})();
